export default __webpack_public_path__ + "static/media/medtronic.65db5300.svg";